"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BULK_CONTACTS_LIMIT = exports.BULK_UPLOAD_ACCEPT_MIME = exports.MAX_BULK_FILE_SIZE = void 0;
var MAX_BULK_FILE_SIZE = 200 * 1024; // 200KiB

exports.MAX_BULK_FILE_SIZE = MAX_BULK_FILE_SIZE;
var BULK_UPLOAD_ACCEPT_MIME = ['.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
exports.BULK_UPLOAD_ACCEPT_MIME = BULK_UPLOAD_ACCEPT_MIME;
var BULK_CONTACTS_LIMIT = 200;
exports.BULK_CONTACTS_LIMIT = BULK_CONTACTS_LIMIT;